import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../../../../infrastructure/assets/images/logo-puc.svg';
import { RootState } from '../../../../infrastructure/redux/store';
import { Container } from '../../shared/components/layout_components/container/styles';
import { FormLogin, FormularioLogin } from '../components/form_login';
import { useAutenticarMutation } from '../graphql/mutations/autenticar.mutation';
import { useTiposUsuarioQuery } from '../graphql/queries/tipos_usuario.query';
import { salvarSessao } from '../reducers/autenticacao.reducer';
import { FormContainer } from '../../shared/components/form_components/container/styles';
import { CanvasLogin } from '../components/canvas_login';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';
import { CanvasService } from '../../../../infrastructure/services/canvas.service';

const LoginPage: React.FC = () => {
  const { theme } = useSelector((state: RootState) => state.theme);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: data_tipos_usuario } = useTiposUsuarioQuery();
  const [autenticar, { loading }] = useAutenticarMutation();

  const fazer_login = async (login: FormLogin) => {
    try {
      const { data } = await autenticar({
        variables: {
          dsc_nome_usuario: login.dsc_nome_usuario,
          id_tipo_usuario: login.id_tipo_usuario,
          senha: login.senha,
          manter_conectado: Boolean(login.manter_conectado),
        },
      });

      if (data) {
        dispatch(
          salvarSessao({
            usuario: login.dsc_nome_usuario as string,
            token: data.autenticar.token,
            refresh_token: data.autenticar.refresh_token,
          })
        );

        navigate('/');
      }
    } catch (error: any) {
      alert(error.message);
    }
  };

  const fazer_login_canvas = () => {
    const canvas_service = new CanvasService();
    canvas_service.redirect_to_canvas_login();
  };

  useEffect(() => {
    document.title = 'Login - SisIEC';
  }, []);

  return (
    <Container>
      <SubContainer flex={3}>
        <Logo fill={theme.colors.textBackground} width={250} />
      </SubContainer>
      <SubContainer flex={2}>
        <FormularioLogin
          onSubmit={fazer_login}
          tiposUsuario={data_tipos_usuario?.tiposUsuario}
          loading={loading}
        />

        <FormContainer flex={0} onSubmit={(e) => e.preventDefault()}>
          <CanvasLogin onClick={fazer_login_canvas} />
        </FormContainer>
      </SubContainer>
    </Container>
  );
};

export { LoginPage };
